import React, { useState } from "react";
import "./DeployOffer.css";

export default function DeployOffer() {
  const [openItems, setOpenItems] = useState([]);

  const accordionItems = [
    {
      id: 1,
      title: "Smart Contract Implementation",
      content: "We help you implement smart contracts for various use cases with seamless integration of blockchain-based automation and transparency. Through meticulous coding and rigorous testing, we ensure that your smart contracts are reliable, secure, and optimized for performance."
    },
    {
      id: 2,
      title: "User Onboarding",
      content: "Streamline the user experience with intuitive onboarding processes that make it easy for users to get started with your decentralized application."
    },
    {
      id: 3,
      title: "User-Friendliness",
      content: "Create intuitive interfaces that prioritize user experience, making blockchain technology accessible to everyone regardless of their technical background."
    },
    {
      id: 4,
      title: "Higher Speed",
      content: "Optimize your dApp for maximum performance with fast transaction processing and efficient smart contract execution."
    },
    {
      id: 5,
      title: "KYC Authorization",
      content: "Implement secure Know Your Customer (KYC) processes to ensure compliance and build trust with your users while maintaining decentralization."
    },
    {
      id: 6,
      title: "Ethereum Development Services",
      content: "Leverage our expertise in Ethereum blockchain development to build robust, scalable decentralized applications on the world's leading smart contract platform."
    }
  ];

  const toggleItem = (id) => {
    if (openItems.includes(id)) {
      setOpenItems(openItems.filter(itemId => itemId !== id));
    } else {
      setOpenItems([...openItems, id]);
    }
  };

  return (
    <div id="deploy-offer" className="dappmainclass">
      <div className="left">
        <h2>What BastionEx Has to Offer for Your Decentralized Application</h2>
        <p>
         BastionEx, as one of the best dApp blockchain application development companies, has all the required resources and expertise to tackle the challenges in dApp development flawlessly, thereby building intuitive applications.
        </p>
      </div>
      <div className="right">
        <div className="accordion">
          {accordionItems.map((item) => (
            <div key={item.id} className={`accordion-item ${openItems.includes(item.id) ? 'active' : ''}`}>
              <div className="accordion-header" onClick={() => toggleItem(item.id)}>
                <span>{item.title}</span>
                <span className="accordion-icon">{openItems.includes(item.id) ? '−' : '+'}</span>
              </div>
              {openItems.includes(item.id) && (
                <div className="accordion-content">
                  <p>{item.content}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}